import * as React from "react";
import { BasePureComponent } from "./BaseComponent";
import { Trad } from "./";
import * as Dati from "../Dati";
import * as Glob from "../Globale";
import { Tipo, BaseAnagrafica, Rubrica, Indirizzi, DatiProfessionali, BottoneAPI } from "../components/";
import { IndiceSedeLegale } from "../components/Indirizzi";
import { useState } from "react";

const productTypeIdsExceptions = [25, 34, 31, 32, 30];
const productTypeIdsAdd = [137];

interface IAccordionAnagraficaProps extends Dati.IBaseProps {
    AnagraficaJSON: Glob.DatiJSON;
    RecapitiJSON: Glob.DatiJSON;
    IndirizziJSON: Glob.DatiJSON;
    DatiProfessionaliJSON: Glob.DatiJSON;
    Indice: number;
    ID_AnagContraente: number;
    ID_TipoProdotto: number;
    ID_TipoAnagPrincipale: string;
    CampoIDAnagrafica: string;
    CampoTipo: string;
    AnagraficaId: string;
    AnagraficaName: string;
    RecapitiId: string;
    RecapitiName: string;
    IndirizziId: string;
    IndirizziName: string;
    DatiProfessionaliId: string;
    DatiProfessionaliName: string;
    StatoAnagrafica?: string;
    OnChangeAppendice?: (e: React.FormEvent<any> | string, valore: any, label: string, fieldTypeId: number, elementGroup: any) => any;
    OnSaveDetails?: () => void;
    OnFirstSaveAttempt?: () => void;
    HasTriedSave: boolean;

}


const addressValidationRule =
    '{"Campo":"Cap", "Regole":[{"Azione": "Required"}]}, {"Campo":"Citta", "Regole":[{"Azione": "Required"}]}, {"Campo":"Indirizzo", "Regole":[{"Azione": "Required"}]}, {"Campo":"Nazione", "Regole":[{"Azione": "Required"}]}, {"Campo":"Provincia", "Regole":[{"Azione": "Required"}]}';

export class AccordionAnagrafica extends BasePureComponent<IAccordionAnagraficaProps> {
    public constructor(props: any) {
        super(props);

        this._Regole = `[{"Campo":"AnnoInizioAttivita", "Regole":[{"Azione": "Required"}]}, {"Campo":"NumeroIscrizione", "Regole":[{"Azione": "Required"}]}, {"Campo":"AnnoIscrizioneAlbo", "Regole":[{"Azione": "Required"}]}, ${addressValidationRule}]`;

        this.RegoleCheck = this.RegoleCheck.bind(this);
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        const professionalData = this.props.DatiProfessionaliJSON ? JSON.parse(this.props.DatiProfessionaliJSON) : {};
        const addresses = this.props.IndirizziJSON ? JSON.parse(this.props.IndirizziJSON) : [];
        const mainAddress = addresses[0] || {};
        const anagrafica = this.props.AnagraficaJSON ? JSON.parse(this.props.AnagraficaJSON) : {};

        if (!this.RegoleCheck({ ...professionalData, ...mainAddress })) {
            const Ingr = new Dati.CIngrAPITipi<Dati.CDatiAnag>();
            Ingr.Dato = JSON.parse(this.props.AnagraficaJSON);
            Ingr.Dato.IndirizziJSON = this.props.IndirizziJSON;
            Ingr.Dato.RecapitiJSON = this.props.RecapitiJSON;
            Ingr.Dato.DatiProfessionaliJSON = this.props.DatiProfessionaliJSON;
            Ingr.Dato.Indirizzo = mainAddress.Indirizzo || "";
            Ingr.Dato.ID_TipoAnagStato = anagrafica.ID_TipoAnagStato
            return Ingr;
        }
        return false;
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {

        const canRenew =
            Glob.GetSessione().Autorizzazioni["RenewalsController"] >= 1;

        if (dati.Errore) {
            let TestoErrore = Trad.Trad(dati.ErrTesto);
            console.warn("data.ErrTesto", dati.ErrTesti[0]);
            console.warn("this.props.HasTriedSave", this.props.HasTriedSave);

            switch (dati.ErrTesti[0]) {
                case "ErroreSanzioni":
                    TestoErrore = Trad.TradParam("ErroreSanzioni:{1-S}", [dati.ErrTesti[1]]);
                    break;
                case "ErroreCodiceFiscale":
                    TestoErrore = Trad.TradParam("Il codice fiscale non è valido", [dati.ErrTesti[1]]);
                    break;
                case "AnagraficaPresenteNelloStessoPortale":
                    TestoErrore = Trad.TradParam("Anagrafica presente", [dati.ErrTesti[1]]);
                    break;
                case "AnagraficaGiaPresente":
                    TestoErrore = Trad.TradParam("Anagrafica già presente. Contattare l'ufficio sottoscrizioni", [dati.ErrTesti[1]]);
                    if (this.props.HasTriedSave && canRenew) {
                        this.props.OnChange(this.props.CampoIDAnagrafica, dati.ID_Chiave);
                        if (this.props.OnSaveDetails) this.props.OnSaveDetails();
                        Glob.InfoModaleSuccess(Trad.Trad("ANAGRAFICA"), Trad.TradParam("Anagrafica salvata correttamente con ID: {1-S}", [dati.ID_Chiave]));
                    }
                    break;      
            }
            Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), TestoErrore);
            this.props.OnFirstSaveAttempt?.();

        }

        else {
            this.props.OnChange(this.props.CampoIDAnagrafica, dati.ID_Chiave);
            if (this.props.OnSaveDetails) this.props.OnSaveDetails();
            Glob.InfoModaleSuccess(Trad.Trad("ANAGRAFICA"), Trad.TradParam("Anagrafica salvata correttamente con ID: {1-S}", [dati.ID_Chiave]));
        }
    }
    //private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
    //    if (dati.Errore) {
    //        let TestoErrore = Trad.Trad(dati.ErrTesto);
    //        if (dati.ErrTesti.length > 0) {
    //            switch (dati.ErrTesti[0]) {
    //                case "ErroreSanzioni":
    //                    TestoErrore = Trad.TradParam("ErroreSanzioni:{1-S}", [dati.ErrTesti[1]]);
    //                    break;
    //            }
    //        }
    //        Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), TestoErrore);
    //    } else {
    //        this.props.OnChange(this.props.CampoIDAnagrafica, dati.ID_Chiave);
    //        if (this.props.OnSaveDetails) this.props.OnSaveDetails();
    //        Glob.InfoModaleSuccess(Trad.Trad("ANAGRAFICA"), Trad.TradParam("Anagrafica salvata correttamente con ID: {1-S}", [dati.ID_Chiave]));
    //    }
    //}

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), errore.message);
    }

    private OnChangeDetailsType = (valore: string) => {
        //console.warn("valore", valore);
        const addresses = this.props.IndirizziJSON && JSON.parse(this.props.IndirizziJSON);
        const isMainAddressRequired = valore == Glob.Tipi_TAP_PersonaGiuridica || valore == Glob.Tipi_TAP_PersonaFisica || valore == Glob.Tipi_TAP_DittaIndividuale;

        if (addresses && isMainAddressRequired) {
            addresses[0].Tipo = [IndiceSedeLegale];
            this.OnChange("IndirizziJSON", JSON.stringify(addresses));
        }
    };

    private UpdateValidationRules = () => {
        if (productTypeIdsExceptions.includes(this.props.ID_TipoProdotto)) {
            this._Regole = `[{"Campo":"AnnoInizioAttivita", "Regole":[{"Azione": "Required"}]}, ${addressValidationRule}]`;
        }
    };

    public render() {
        let anagrafica: any;
        let ID_TipoAnagPrincipale: string = "";

        if (this.props.AnagraficaJSON != undefined && this.props.AnagraficaJSON != "") {
            if (typeof this.props.AnagraficaJSON == "string") {
                anagrafica = JSON.parse(this.props.AnagraficaJSON);
            } else {
                anagrafica = this.props.AnagraficaJSON;
            }
            ID_TipoAnagPrincipale = anagrafica.ID_TipoAnagPrincipale;
        }

        let TestataAnagrafica: any[] = [];

        if (this.props.ID_AnagContraente == 0) {
            TestataAnagrafica.push(<i key={1} className="la la-user-plus"></i>);
            TestataAnagrafica.push(Trad.Trad("Inserisci"));
        } else {
            TestataAnagrafica.push(<i key={2} className="la la-user"></i>);
            TestataAnagrafica.push(Trad.Trad("Visualizza"));
        }
        this.UpdateValidationRules();

        return (
            <div className="card-header active">
                <a
                    href={"#kt_accordion_1_item_" + this.props.Indice + "_body"}
                    className="card-title collapsed"
                    role="tab"
                    id={"kt_accordion_1_item_" + this.props.Indice + "_head"}
                    data-toggle="collapse"
                    aria-expanded="false"
                >
                    <span className="accordion__item-icon">
                        <i className="fa flaticon-avatar"></i>
                    </span>
                    <span className="accordion__item-icon">{Trad.Trad("Anagrafica")}</span>
                    <span className="kt-accordion__item-mode"></span>
                </a>
                <div
                    className="kt-accordion__itekt-body collapse spazioVerticale"
                    id={"kt_accordion_1_item_" + this.props.Indice + "_body"}
                    role="tabpanel"
                    aria-labelledby={"kt_accordion_1_item_" + this.props.Indice + "_head"}
                    data-parent="#kt_accordion_1"
                >
                    <div className="kt-portlet kt-portlet--tabs">
                        <div className="kt-portlet__head">
                            <div className="portlet__head-tools" wfd-id="48">
                                <ul className="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-left nav-tabs-line-success" role="tablist">
                                    <li className="nav-item kt-tabs__item">
                                        <a className="nav-link tabs__link active" data-toggle="tab" href="#kt_portlet_base_anagrafica_1_1_tab_content" role="tab">
                                            <i className="la la-search"></i> Ricerca
                                        </a>
                                    </li>
                                    <li className="nav-item kt-tabs__item">
                                        <a className="nav-link tabs__link" data-toggle="tab" href="#kt_portlet_base_anagrafica_1_2_tab_content" role="tab">
                                            {TestataAnagrafica}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="kt-portlet__body">
                            <div className="tab-content">
                                <div className="tab-pane active" id="kt_portlet_base_anagrafica_1_1_tab_content" role="tabpanel">
                                    <Tipo
                                        URL="/api/Anag/RicercaVeloceRCP?id_TipoAnag=&ricerca="
                                        Campo={this.props.CampoTipo}
                                        ID_Chiave={this.props.ID_AnagContraente}
                                        OnAggiorna={(e, v) => {
                                            this.props.OnChange(e, v);
                                        }}
                                        TradValori
                                        LinkSelezione="/anagrafica/"
                                    />
                                </div>
                                <div className="tab-pane" id="kt_portlet_base_anagrafica_1_2_tab_content" role="tabpanel">
                                    <BaseAnagrafica
                                        Id={this.props.AnagraficaId}
                                        Name={this.props.AnagraficaName}
                                        OnChange={this.props.OnChange}
                                        OnChangeDetailsType={this.OnChangeDetailsType}
                                        OnChangeAppendice={this.props.OnChangeAppendice}
                                        Value={JSON.stringify(anagrafica)}
                                    />
                                    <div className="kt-separator kt-separator--dashed kt-separator--lg"></div>
                                    <Rubrica
                                        Id={this.props.RecapitiId}
                                        Name={this.props.RecapitiName}
                                        Value={this.props.RecapitiJSON}
                                        OnChange={this.props.OnChange}
                                        OnChangeAppendice={this.props.OnChangeAppendice}
                                    />
                                    <div className="kt-separator kt-separator--dashed kt-separator--lg"></div>
                                    <Indirizzi
                                        Id={this.props.IndirizziId}
                                        Name={this.props.IndirizziName}
                                        Value={this.props.IndirizziJSON}
                                        OnChange={this.props.OnChange}
                                        OnChangeAppendice={this.props.OnChangeAppendice}
                                        ID_TipoAnagPrincipale={ID_TipoAnagPrincipale}
                                    />
                                    <div className="kt-separator kt-separator--dashed kt-separator--lg"></div>
                                    <DatiProfessionali
                                        Id={this.props.DatiProfessionaliId}
                                        Name={this.props.DatiProfessionaliName}
                                        OnChange={this.props.OnChange}
                                        OnChangeAppendice={this.props.OnChangeAppendice}
                                        Parametri='[{"Campo": "AnnoInizioAttivita","Etichetta": "AnnoInizioAttivita","ID_TipoCampo": 2,"DimensioneGrafica": 4}, {"Campo": "NumeroIscrizione","Etichetta": "NumeroIscrizione","ID_TipoCampo": 2,"DimensioneGrafica": 4}, {"Campo": "AnnoIscrizioneAlbo","Etichetta": "AnnoIscrizioneAlbo","ID_TipoCampo": 2,"DimensioneGrafica": 4}]'
                                        Dati={this.props.DatiProfessionaliJSON}
                                    />
                                    {!this.props.OnChangeAppendice && (
                                        <React.Fragment>
                                            <div className="kt-separator kt-separator--dashed kt-separator--lg"></div>
                                            <div className="col kt--align-right">
                                                <BottoneAPI
                                                    Default={false}
                                                    Testo={Trad.Trad("Salva anagrafica")}
                                                    URL={`/api/anag/SalvaAnagraficaAsync?sbloccata=${this.props.HasTriedSave}`}
                                                    Metodo="POST"
                                                    OnInvio={s => this.OnInvioSalva(s)}
                                                    OnClick={(s, d) => this.OnClickSalva(s, d)}
                                                    OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                    Visibile={this._Scrittura}
                                                />
                                            </div>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AccordionAnagrafica.tsx